import React from 'react';
import styled from '@emotion/styled';
import { Button } from '~/shared/components/Button/Button';
import Delete from '~/icons/close.svg';
import { StyledButton } from '~/shared/components/Button/styled';
import {
    GiftCertificateItem,
    GiftCertificateTitle,
    GiftCertificateItemCancel,
} from './GiftCertificateItem';
import { useTranslation } from '~/shared/utils/translation';

export type Props<T extends { code: string; name: string; id: string }> = {
    activeCodes: T[];
    onRemove: (elm: T) => void;
    className?: string;
};

function ActiveCodeList<T extends { code: string; name: string; id: string }>(props: Props<T>) {
    const { activeCodes, className, onRemove } = props;
    const { translate } = useTranslation();

    return (
        <ul className={className}>
            {activeCodes.map((code) => (
                <GiftCertificateItem key={code.id}>
                    <div>
                        <GiftCertificateTitle>{code.name}</GiftCertificateTitle>
                        <p>{code.code}</p>
                    </div>

                    <GiftCertificateItemCancel>
                        <Button onClick={() => onRemove?.(code)} variant="plain">
                            <span>{translate('basket.cancel')}</span>
                            <Delete />
                        </Button>
                    </GiftCertificateItemCancel>
                </GiftCertificateItem>
            ))}
        </ul>
    );
}

export const StyledActiveCodes = styled(ActiveCodeList)(({ theme }) => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    '&:empty': {
        paddingBottom: theme.space[4],
    },
    [`${StyledButton}`]: {
        svg: {
            width: 10,
            height: 14,
        },
    },
}));
